a.vars = (function(){
	return {
		version:4
	}
}());